/** Nombre de persona para ES / EN / PT: letras (tildes, ñ, ç), espacios, guion, apóstrofe e inicial. */
const PERSON_NAME_RE = /^[\p{L}][\p{L}\p{M}\s.'’-]*$/u;

export function normalizePersonName(value: string): string {
  return value.trim().replace(/\s+/g, ' ');
}

export function looksLikePersonName(value: string): boolean {
  const name = normalizePersonName(value);
  if (name.length < 2) return false;
  if (!PERSON_NAME_RE.test(name)) return false;
  const letters = name.match(/\p{L}/gu) ?? [];
  return letters.length >= 2;
}
